import jwtDecode from "jwt-decode";

const REFRESH_BEFORE_EXPIRY_MS = 60 * 1000;
// setTimeout overflows above 2^31-1 ms (~24.8 days) and fires immediately.
export const MAX_TIMEOUT_MS = 2 ** 31 - 1;

/** Hasura rejects with its `errors` array; an expired token is `invalid-jwt`. */
export const isJwtError = (error) =>
  Array.isArray(error) &&
  error.some(
    (e) =>
      e?.extensions?.code === "invalid-jwt" ||
      String(e?.message ?? "").includes("JWTExpired"),
  );

const decodeClaims = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

/** ms until the token should be renewed, or null when it has no `exp`. */
export const msUntilRenewal = (token, now = Date.now()) => {
  const claims = decodeClaims(token);
  if (!claims?.exp) return null;
  const expiresAt = claims.exp * 1000;
  const lifetime = claims.iat ? expiresAt - claims.iat * 1000 : Infinity;
  // Short-lived tokens renew at half-life so a renewal never yields a token
  // that is already inside the margin (which would loop).
  const margin = Math.min(REFRESH_BEFORE_EXPIRY_MS, lifetime / 2);
  return Math.max(expiresAt - margin - now, 0);
};
